<div class="sticky-bar">
  <div class="sticky-bar-left">
    <span>Travel Calendar</span>
  </div>
</div>

<div class="calendar-container">
  <!-- Calendar Header -->
  <div class="calendar-header">
    <button (click)="prevMonth()">&#8249;</button>
    <span>{{ currentMonth.format("MMMM YYYY") }}</span>
    <button (click)="nextMonth()">&#8250;</button>
  </div>

  <!-- Days of the Week -->
  <div class="calendar-grid calendar-days">
    <div *ngFor="let day of weekDays" class="calendar-weekday">
      {{ day }}
    </div>
  </div>

  <!-- Calendar Grid -->
  <div class="calendar-grid">
    <div *ngFor="let day of daysInMonth" 
         class="calendar-day"
         [ngClass]="{ 
           'current-day': day && isToday(day), 
           'has-event': day && getEvents(day).length > 0 
         }">
      
      <!-- Only show content if day is not null -->
      <ng-container *ngIf="day; else emptyDay">
        <!-- Day Number -->
        <span class="day-number">{{ day.format("D") }}</span>
  
        <!-- Multi-Day Events -->
        <div *ngFor="let event of getEvents(day)"
             class="event"
             [ngClass]="{
               'event-start': isStartOfEvent(day, event),
               'event-middle': !isStartOfEvent(day, event) && !isEndOfEvent(day, event),
               'event-end': isEndOfEvent(day, event)
             }"
             [style.background]="userColors[event.userId]">
             <div class="event-title">
              {{ event.title }}
            </div>
        </div>
      </ng-container>

      <!-- Template for empty day cells -->
      <ng-template #emptyDay></ng-template>
    </div>
  </div>
</div>
